import { CandleBreakLine } from '../../../charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/entryTactics/CandleBreakLine';
import { AtrTrailLine } from '../../../charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/exitTactics/AtrTrailLine';
import { BreakPriceLine } from '../../../charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/exitTactics/BreakPriceLine';
import { CandleMagnitudeLine } from '../../../charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/exitTactics/CandleMagnitudeLine';
import { CandleTrailLine } from '../../../charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/exitTactics/CandleTrailLine';
import { GrabCentsLine } from '../../../charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/exitTactics/GrabCentsLine';
import { GreenToRedCandlesLine } from '../../../charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/exitTactics/GreenToRedCandlesLine';
import { GreenToRedPositionsLine } from '../../../charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/exitTactics/GreenToRedPositionsLine';
import { LossLimitLine } from '../../../charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/exitTactics/LossLimitLine';
import { MfeRetracementLine } from '../../../charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/exitTactics/MfeRetracementLine';
import { PositionBreakPriceLine } from '../../../charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/exitTactics/PositionBreakPriceLine';
import { PositionPriceTrailLine } from '../../../charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/exitTactics/PositionPriceTrailLine';
import { PreserveProfitLine } from '../../../charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/exitTactics/PreserveProfitLine';
import { RatchetBracketLine } from '../../../charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/exitTactics/RatchetBracketLine';
import { UnderlyingPriceExitLine } from '../../../charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/exitTactics/UnderlyingPriceExitLine';
import { UnderlyingPriceTrailLine } from '../../../charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/exitTactics/UnderlyingPriceTrailLine';
import { AddToWinnerLine } from '../../../charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/positionTactics/AddToWinnerLine';
import { ScalingInLine } from '../../../charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/positionTactics/ScalingInLine';
import { EmaIntersectsFirstCandleLine } from '../../../charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/setupFilters/EmaIntersectsFirstCandleLine';
import { FTFCBoxes } from '../../../charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/setupFilters/FTFCBoxes';
import { PriceIntersectsFirstCandleLine } from '../../../charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/setupFilters/PriceIntersectsFirstCandleLine';
import { TimeOfDayBox } from '../../../charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/setupFilters/TimeOfDayBox';
import { BounceEmaLine } from '../../../charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/setups/BounceEmaLine';
import { BounceLine } from '../../../charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/setups/BounceLine';
import { BreakCandleTypeLine } from '../../../charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/setups/BreakCandleTypeLine';
import { BreakEmaLine } from '../../../charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/setups/BreakEmaLine';
import { BreakLine } from '../../../charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/setups/BreakLine';
import { CandlePatternBox } from '../../../charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/setups/CandlePatternBox';
import { CandleTriggerLine } from '../../../charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/setups/CandleTriggerLine';
import { ConvictionCandleLine } from '../../../charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/setups/ConvictionCandleLine';
import { FlagPatternBox } from '../../../charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/setups/FlagPatternBox';
import { OrbLine } from '../../../charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/setups/OrbLine';

interface Map {
  [index: string]: any;
}
export const lineComponentMap: Map = {
  //setups
  BREAK: BreakLine,
  BOUNCE: BounceLine,
  CONVICTION_CANDLE: ConvictionCandleLine,
  CANDLE_TRIGGER: CandleTriggerLine,
  BREAK_CANDLE_TYPE: BreakCandleTypeLine,
  ORB: OrbLine,
  BOUNCE_EMA: BounceEmaLine,
  BREAK_EMA: BreakEmaLine,
  CANDLE_PATTERN: CandlePatternBox,
  FLAG: FlagPatternBox,

  //setupFilters
  PRICE_INTERSECTS_FIRST_CANDLE: PriceIntersectsFirstCandleLine,
  EMA_INTERSECTS_FIRST_CANDLE: EmaIntersectsFirstCandleLine,
  TIME_OF_DAY: TimeOfDayBox,
  FTFC_FILTER: FTFCBoxes,

  //entries
  MARKET_ORDER: null,
  LIMIT_ORDER: null,
  CANDLE_BREAK: CandleBreakLine,

  //position
  ADD_TO_WINNER: AddToWinnerLine,
  SCALING_IN: ScalingInLine,

  //exits
  BREAK_PRICE: BreakPriceLine,
  CANDLE_TRAIL: CandleTrailLine,
  GRAB_CENTS: GrabCentsLine,
  GREEN_TO_RED_CANDLES: GreenToRedCandlesLine,
  GREEN_TO_RED_POSITIONS: GreenToRedPositionsLine,
  LOSS_LIMIT: LossLimitLine,
  POSITION_PRICE_TRAIL: PositionPriceTrailLine,
  PRESERVE_PROFIT: PreserveProfitLine,
  RATCHET_BRACKET: RatchetBracketLine,
  CANDLE_MAGNITUDE: CandleMagnitudeLine,
  UNDERLYING_PRICE_TRAIL: UnderlyingPriceTrailLine,
  ATR_TRAIL: AtrTrailLine,
  MFE_RETRACEMENT: MfeRetracementLine,
  UNDERLYING_PRICE_EXIT: UnderlyingPriceExitLine,
  POSITION_BREAK_PRICE: PositionBreakPriceLine,
};

/* 
export const detailsSectionRows = {
  //setups
  BREAK: TacticRow,
  BOUNCE: TacticRow,
  CONVICTION_CANDLE: TacticRow,
  CANDLE_TRIGGER: TacticRow,
  BREAK_CANDLE_TYPE: TacticRow,
  ORB: TacticRow,
  BOUNCE_EMA: TacticRow,
  BREAK_EMA: TacticRow,
  CANDLE_PATTERN: TacticRow,
  FLAG: TacticRow,

  //setupFilters
  PRICE_INTERSECTS_FIRST_CANDLE: TacticRow,
  EMA_INTERSECTS_FIRST_CANDLE: TacticRow,
  TIME_OF_DAY: TacticRow,
  FTFC_FILTER: TacticRow,

  //entries
  MARKET_ORDER: TacticRow,
  LIMIT_ORDER: TacticRow,
  CANDLE_BREAK: TacticRow,

  //position
  ADD_TO_WINNER: TacticRow,
  SCALING_IN: TacticRow,

  //exits
  BREAK_PRICE: TacticRow,
  CANDLE_TRAIL: TacticRow,
  GRAB_CENTS: TacticRow,
  GREEN_TO_RED_CANDLES: TacticRow,
  GREEN_TO_RED_POSITIONS: TacticRow,
  LOSS_LIMIT: TacticRow,
  POSITION_PRICE_TRAIL: TacticRow,
  PRESERVE_PROFIT: TacticRow,
  RATCHET_BRACKET: TacticRow,
  CANDLE_MAGNITUDE: TacticRow,
  UNDERLYING_PRICE_TRAIL: TacticRow,
};
 */
